"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return ExtraSmallLogo;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function ExtraSmallLogo(props) {
    var svgProps = Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 82 20",
        width: "82",
        height: "20",
        fill: "none"
    }, props);
    return /*#__PURE__*/ _react.createElement("svg", _extends({}, svgProps), /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.93882 2.3151C9.29459 1.5472 8.14995 1.44704 7.38219 2.09138L5.60345 3.58418C6.19088 3.78112 6.7331 4.13735 7.1605 4.6468L9.04952 6.89844L11.8278 4.56674L9.93882 2.3151ZM2.25624 4.21766L6.31107 0.814645C7.78383 -0.421366 9.97954 -0.229232 11.2153 1.24379L13.6399 4.1338C13.7819 4.30311 13.8509 4.52191 13.8317 4.74209C13.8124 4.96226 13.7065 5.16576 13.5372 5.30782L11.92 6.66504L14.1855 9.3654C15.4213 10.8384 15.2292 13.0345 13.7564 14.2705L7.90168 19.1841C7.90119 19.1845 7.9007 19.1849 7.90022 19.1854C6.42746 20.4214 4.23175 20.2292 2.99596 18.7562L0.19493 15.4175C0.0528908 15.2482 -0.0160864 15.0294 0.00317275 14.8092C0.0224319 14.589 0.12835 14.3855 0.297626 14.2435L3.71619 11.3744L1.82717 9.12279C0.591381 7.64977 0.783481 5.45367 2.25624 4.21766ZM4.78731 12.6512L2.007 14.9845L4.27247 17.6849C4.91669 18.4528 6.06134 18.553 6.8291 17.9086C7.59686 17.2643 7.697 16.1194 7.05277 15.3515L4.78731 12.6512ZM9.10519 15.9984C9.01329 15.3856 8.75669 14.7897 8.32929 14.2802L3.10368 8.05148C2.45946 7.28358 2.5596 6.13874 3.32736 5.4944C4.09512 4.85005 5.23976 4.95021 5.88399 5.71811L8.30857 8.60812C8.45061 8.77743 8.65407 8.88337 8.87421 8.90263C9.09434 8.92189 9.31311 8.8529 9.48238 8.71084L10.6435 7.73635L12.909 10.4367C13.5532 11.2046 13.4531 12.3495 12.6853 12.9938L9.10519 15.9984Z",
        fill: "#384241"
    }), /*#__PURE__*/ _react.createElement("g", {
        clipPath: "url(#clip0_72_1349)"
    }, /*#__PURE__*/ _react.createElement("path", {
        d: "M22.2086 16.4437C21.8055 16.4437 21.4984 16.6162 21.3644 16.942H21V12.7593H21.5184C22.0747 14.5628 23.6097 15.9446 25.356 15.9446C26.8144 15.9446 27.7739 15.0785 27.7739 13.8912C27.7739 12.5101 26.8144 11.3774 25.1255 10.3034L23.0507 8.99823C21.6696 8.1321 21.0553 7.25264 21.0553 6.0054C21.0553 4.22049 22.7822 3.03122 25.392 3.03122C26.6579 3.03122 27.2335 3.3377 27.8285 3.3377C28.095 3.3377 28.3275 3.24243 28.3662 3.0119H28.654L29.8466 6.69565H29.2516C28.676 5.06464 27.3141 4.08658 25.5679 4.08658C24.1094 4.08658 23.2846 4.62358 23.2846 5.50637C23.2846 6.08202 23.5917 6.5997 24.7617 7.30994L27.1815 8.76837C29.1543 9.95565 30.1131 11.3008 30.1131 13.1624C30.1131 15.5029 28.3095 17 25.6232 17C23.8969 17 22.9568 16.4437 22.2086 16.4437Z",
        fill: "#384241"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M31.1312 11.9344C31.1312 8.92159 33.3185 6.92615 36.3693 6.92615C38.8065 6.92615 40.3222 8.13474 40.3222 9.45793C40.3222 10.0336 39.8805 10.418 39.2862 10.418C37.3674 10.418 38.2868 7.92354 36.3693 7.92354C34.7576 7.92354 33.5297 9.53522 33.5297 11.9337C33.5297 14.255 34.7956 15.8094 36.7151 15.8094C38.3075 15.8094 39.4587 14.8306 39.8232 13.1617H40.3795C40.2263 15.4269 38.4993 16.9413 36.0622 16.9413C33.1073 16.942 31.1312 14.9466 31.1312 11.9344Z",
        fill: "#384241"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M48.0547 8.3653C48.0547 9.09419 47.655 9.61254 46.9614 9.61254C46.2285 9.61254 46.0213 8.82569 45.4643 8.82569C44.7161 8.82569 44.2171 9.82508 44.2171 11.5314V15.0625C44.2171 16.0413 44.5435 16.2138 45.483 16.2525V16.7322H41.3202V16.2525C41.6846 16.2138 42.0104 16.0413 42.0104 15.4463V9.17147C42.0104 8.61448 41.6846 8.53786 41.3202 8.53786V8.05816L43.6414 6.9455H44.1045L44.1811 8.97959C44.5809 7.67439 45.4283 6.90686 46.5217 6.90686C47.4411 6.90686 48.0547 7.52115 48.0547 8.3653Z",
        fill: "#384241"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M52.6214 16.2518V16.7315H49.0349V16.2518C49.3993 16.2132 49.7258 16.0406 49.7258 15.4456V9.17147C49.7258 8.61448 49.3993 8.53786 49.0349 8.53786V8.05815L51.4714 6.9455H51.9324V15.4456C51.9311 16.0406 52.2569 16.2132 52.6214 16.2518ZM49.398 4.61035C49.398 4.32572 49.4824 4.04748 49.6405 3.81082C49.7986 3.57416 50.0234 3.3897 50.2864 3.28078C50.5493 3.17186 50.8387 3.14336 51.1179 3.19889C51.397 3.25442 51.6534 3.39148 51.8547 3.59274C52.056 3.79401 52.193 4.05043 52.2486 4.32959C52.3041 4.60876 52.2756 4.89812 52.1667 5.16108C52.0578 5.42404 51.8733 5.6488 51.6366 5.80694C51.4 5.96507 51.1217 6.04947 50.8371 6.04947C50.6476 6.05134 50.4596 6.01539 50.2842 5.94373C50.1087 5.87207 49.9493 5.76614 49.8153 5.63213C49.6813 5.49812 49.5754 5.33873 49.5037 5.16328C49.432 4.98784 49.3961 4.79986 49.398 4.61035Z",
        fill: "#384241"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M63.8464 11.9344C63.8464 14.9466 61.9849 16.942 59.1826 16.942C57.8967 16.942 56.8221 16.3664 56.2657 15.4456C55.5555 15.5789 55.0572 16.1938 54.9033 16.942H54.2703V5.23779C54.2703 4.6808 53.9438 4.60376 53.5794 4.60376V4.12439L56.0166 3.01172H56.4769V8.59581C56.9946 7.54045 58.1273 6.92616 59.4891 6.92616C62.1002 6.92616 63.8464 8.92161 63.8464 11.9344ZM61.4479 11.9344C61.4479 9.66915 60.3925 8.1734 58.8002 8.1734C57.401 8.1734 56.4783 9.38199 56.4783 11.1856V12.9318C56.4783 14.6208 57.399 15.7528 58.8002 15.7528C60.3925 15.7521 61.4479 14.2197 61.4479 11.9344Z",
        fill: "#384241"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M73.6324 13.3156H74.1887C74.0554 15.4842 72.2892 16.942 69.7754 16.942C66.8778 16.942 64.9597 14.9432 64.9597 11.9344C64.9597 8.92559 66.9165 6.92615 69.8713 6.92615C72.519 6.92615 74.2846 8.76835 74.2846 11.5506H67.3569V11.9344C67.3569 14.275 68.6228 15.8294 70.5043 15.8294C72.0587 15.8294 73.2293 14.8893 73.6324 13.3156ZM67.4542 10.6679H71.7902C71.7329 9.01753 70.9653 7.9242 69.8334 7.9242C68.6434 7.9242 67.7413 8.97956 67.4542 10.6679V10.6679Z",
        fill: "#384241"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M81.6915 8.3653C81.6915 9.09419 81.2885 9.61254 80.5975 9.61254C79.8687 9.61254 79.6575 8.82569 79.1011 8.82569C78.3529 8.82569 77.8539 9.82508 77.8539 11.5314V15.0625C77.8539 16.0413 78.1797 16.2138 79.1198 16.2525V16.7322H74.9563V16.2525C75.3208 16.2138 75.6473 16.0413 75.6473 15.4463V9.17147C75.6473 8.61448 75.3208 8.53786 74.9563 8.53786V8.05816L77.2783 6.9455H77.7386L77.8153 8.97959C78.215 7.67439 79.0625 6.90686 80.1565 6.90686C81.0773 6.90686 81.6915 7.52115 81.6915 8.3653Z",
        fill: "#384241"
    })), /*#__PURE__*/ _react.createElement("defs", null, /*#__PURE__*/ _react.createElement("clipPath", {
        id: "clip0_72_1349"
    }, /*#__PURE__*/ _react.createElement("rect", {
        width: "60.7644",
        height: "14",
        fill: "white",
        transform: "translate(21 3)"
    }))));
}

//# sourceMappingURL=ExtraSmallLogo.js.map